import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowsImportRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-import',
	path: '/plugins/servlet/wfshare-(import|export)',
};
